import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Container} from '@material-ui/core';
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  card: {
    backgroundColor: theme.palette.info.main
  },
  content: {
    color:"white",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2)
  },
  container: {
    margin: theme.spacing(0)
  }
}));

const PeraturanPCAB = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Container className={classes.container}>
      <Card className={classes.card}>
      <CardActions disableSpacing>
        <Alert variant="filled" severity="info">
          <AlertTitle>{"Peraturan Rangkaian PCAB KSR PMI Unit UNJ"}</AlertTitle>
            <Typography variant="body2">
              {
                "Berikut kegiatan PCAB KSR PMI Unit UNJ yang harus diperhatikan"
              }
            </Typography>
        </Alert>
        <IconButton
        className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
        })}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="show more"
        >
        <ExpandMoreIcon />
        </IconButton>
      </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Container>
            <CardContent className={classes.content}>
            <Typography variant="body1" gutterBottom>{"TATA TERTIB PESERTA PENDIDIKAN DAN LATIHAN (DIKLAT)"}</Typography>
              <Typography variant="body2">{"1. Peserta harus memasuki ruang zoom sebelum pukul 07.45 WIB"}</Typography>
              <Typography variant="body2">{"2. Peserta harus bersikap dan berbicara baik"}</Typography>
              <Typography variant="body2">{"3. Peserta dilarang merokok selama mengikuti kegiatan"}</Typography>
              <Typography variant="body2">{"4. Peserta harus memakai atribut yang sudah ditentukan oleh panitia"}</Typography>
              <Typography variant="body2">{"5. Peserta memanggil panitia, anggota dan alumni dengan panggilan “kakak” yang diikuti dengan nama"}</Typography>
              <Typography variant="body2">{"6. Peserta memanggil sesama peserta dengan panggilan “cakas” dengan diikuti nama"}</Typography>
              <Typography variant="body2">{"7. Peserta harus meminta izin kepada koor peserta/ panitia sie acara/ ketuplak bila ingin meninggalkan ruang zoom atau sebagian acara diklat"}</Typography>
              <Typography variant="body2">{"8. Peserta harus mengisi daftar hadir selama acara berlangsung"}</Typography>
              <Typography variant="body2">{"9. Peserta harus mengikuti intruksi yang sudah diberikan panitia (Sie Acara)"}</Typography>
              <Typography variant="body2">{"10. Peserta wajib mengikuti seluruh materi yang sudah disiapkan dan apabila ada yang berhalangan hadir segera konfirmasi ke Sie Acara"}</Typography>
              <Typography variant="body2">{"11. Jika peserta membuat kegaduhan maka peserta akan mendapatkan sanksi dari panitia"}</Typography>
              <Typography variant="body2">{"12.	Jika peserta berkelahi sesama peserta atau panitia, peserta akan dikeluarkan dari forum dan dinyatakan gugur"}</Typography>
              <Typography variant="body2" paragraph>{"13.	Hal- hal yang belum tercantum akan dicantumkan selanjutnya berdasarkan kesepakatan panitia"}</Typography>
            <Typography variant="body1" gutterBottom>{"SANKSI"}</Typography>
              <Typography variant="body2">{"1. Teguran"}</Typography>
              <Typography variant="body2">{"2. Seri per kesalahan (Push Up/Back Up/Squad/Burpee)"}</Typography>
              <Typography variant="body2">{"3. Dikeluarkan dari forum"}</Typography>
              <Typography variant="body2">{"4. Dinyatakan Gugur"}</Typography>
            </CardContent>
          </Container>
        </Collapse>
        </Card>
    </Container>
  );
}

export default PeraturanPCAB